import { apiV2Prefix } from "@macrostrat-web/settings";

var Config = {
  apiURL: apiV2Prefix,
  pbdbURL: "https://paleobiodb.org/data1.2",

  totalColumns: 1681,

  // http://color.hailpixel.com/#366EA6,F9D862,DD98BC,111111,C96566,3D9970,D06CAD,6D3B22,D76433,BD3239,AB6836,
  lithColors: {
    carbonate: "#366EA6",
    siliciclastic: "#F9D862",
    evaporite: "#DD98BC",
    organic: "#111111",
    chemical: "#c96566",
    volcanic: "#3D9970",
    plutonic: "#D06CAD",
    metamorphic: "#6D3B22",
    sedimentary: "#D76433",
    igneous: "#BD3239",
    metasedimentary: "#AB6836",
    "1": "#FFF400",
    "2": "#FFAB00",
    "3": "#FFCA00",
    "4": "#919AA3",
    "5": "#A7ACB0",
    "6": "#B2B5B7",
    "7": "#9CA3AA",
    "8": "#7B8896",
    "9": "#86919D",
    "10": "#FFD500",
    "11": "#FFEA00",
    "12": "#FFDF00",
    "14": "#FFC000",
    "15": "#FFB500",
    "16": "#FF9600",
    "17": "#0000FF",
    "18": "#0508FD",
    "19": "#0B11FC",
    "20": "#111AFB",
    "21": "#1723FA",
    "22": "#1D2BF9",
    "23": "#2334F8",
    "24": "#293DF7",
    "25": "#2F46F6",
    "26": "#344EF5",
    "27": "#3A57F4",
    "28": "#4060F3",
    "29": "#4669F2",
    "30": "#4C71F1",
    "31": "#527AF0",
    "32": "#5883EF",
    "33": "#5E8CEE",
    "34": "#FFB6C1",
    "35": "#F9AFBA",
    "36": "#F3A8B3",
    "37": "#EEA2AD",
    "38": "#000000",
    "39": "#090F0F",
    "40": "#121F1F",
    "43": "#1C2F2F",
    "44": "#253F3F",
    "45": "#CD5C5C",
    "46": "#C96566",
    "47": "#C66F70",
    "48": "#C37879",
    "49": "#FFFF00",
    "52": "#FF4500",
    "53": "#FF4208",
    "54": "#FF3F11",
    "55": "#FF3C19",
    "56": "#FF3922",
    "57": "#FF362B",
    "58": "#FF3333",
    "59": "#FF303C",
    "60": "#FF2D45",
    "61": "#FF2B4D",
    "62": "#FF2856",
    "63": "#006400",
    "64": "#096C09",
    "65": "#127512",
    "66": "#1B7D1B",
    "67": "#248624",
    "68": "#2C8F2C",
    "69": "#369736",
    "70": "#3FA03F",
    "71": "#48A948",
    "72": "#51B151",
    "73": "#59BA59",
    "74": "#63C263",
    "75": "#6CCB6C",
    "76": "#75D475",
    "77": "#7EDC7E",
    "78": "#8B4513",
    "79": "#8E491B",
    "80": "#914E23",
    "81": "#94532B",
    "82": "#985834",
    "83": "#9B5D3C",
    "84": "#9E6244",
    "85": "#A1674C",
    "86": "#A56C55",
    "87": "#A8715D",
    "88": "#AB7665",
    "89": "#AE7B6D",
    "90": "#B28076",
    "91": "#708090",
    "92": "#6495ED",
    "93": "#BEBEBE",
    "94": "#FF255F",
    "95": "#FF0000",
    "96": "#87E587",
    "97": "#FFA000",
    "98": "#B5857E",
    "99": "#FF2267",
    "100": "#FF1F70",
    "101": "#FF1C79",
    "102": "#90EE90",
    "103": "#BF8283",
    "104": "#BC8B8E",
    "105": "#FF1981",
    "106": "#B99598",
    "107": "#FF168A",
    "108": "#FF1493",
    "109": "#B88A86",
    "110": "#BC8F8F",
    "111": "#FF8C00",
    "112": null,
    "113": "#FFDF00",
    "114": "#527AF0",
  },

  // http://color.hailpixel.com/#366EA6,F9D862,33A373,31909B,635A21,BFECF3,B8794C,366EA6,635A21,
  environColors: {
    carbonate: "#366EA6",
    siliciclastic: "#F9D862",
    fluvial: "#33A373",
    lacustrine: "#31909B",
    landscape: "#635A21",
    glacial: "#BFECF3",
    eolian: "#B8794C",
    marine: "#366EA6",
    "non-marine": "#635A21",
    Unknown: "#777777",
    "1": "#B8B8E6",
    "2": "#3399FF",
    "3": "#3399FF",
    "4": "#B8B8E6",
    "5": "#5CADFF",
    "6": "#33CCFF",
    "7": "#33CCFF",
    "8": "#33CCFF",
    "9": "#2EB8E6",
    "10": "#2EB8E6",
    "11": "#297ACC",
    "12": "#297ACC",
    "13": "#246BB2",
    "14": "#246BB2",
    "15": "#246BB2",
    "16": "#1F5C99",
    "17": "#1F5C99",
    "18": "#1F5C99",
    "19": "#1A4C80",
    "20": "#1A4C80",
    "21": "#007A5C",
    "22": "#007A5C",
    "23": "#007A5C",
    "24": "#007A5C",
    "25": "#33D6AD",
    "26": "#99EBD6",
    "27": "#80E6CC",
    "28": "#B2F0E0",
    "29": "#19D1A3",
    "30": "#19D1A3",
    "31": "#00B88A",
    "32": "#00CC99",
    "33": "#00CC99",
    "34": "#00523D",
    "35": "#00291F",
    "36": "#00291F",
    "37": "#00664C",
    "38": "#CCFFFF",
    "39": "#00B88A",
    "41": "#FFD6AD",
    "42": "#FFD6AD",
    "43": "#FFCC99",
    "44": "#FFEAD6",
    "45": "#669900",
    "46": "#75A319",
    "47": "#669900",
    "48": "#5C8A00",
    "49": "#5C8A00",
    "52": "#A3C266",
    "55": "#94B84D",
    "56": "#94B84D",
    "57": "#669900",
    "58": "#75A319",
    "59": "#75A319",
    "61": "#00B88A",
    "62": "#D6D6FF",
    "63": "#DBDBFF",
    "64": "#DBDBFF",
    "65": "#DBDBFF",
    "66": "#DBDBFF",
    "67": "#DBDBFF",
    "68": "#8AE68A",
    "69": "#8AE68A",
    "70": "#8AE68A",
    "71": "#8AE68A",
    "72": "#EBFFEB",
    "73": "#ADFFAD",
    "74": "#6BB26B",
    "75": "#7ACC7A",
    "76": "#A3FFA3",
    "77": "#ADFFAD",
    "78": "#E0FFE0",
    "79": "#D6D6C2",
    "80": "#D6D6C2",
    "81": "#3D3D29",
    "82": "#999966",
    "83": "#B8B894",
    "84": "#6B6B47",
    "85": "#F5F5F0",
    "86": "#6B6B47",
    "87": "#D6D6C2",
    "88": "#CCFFCC",
    "89": "#74CDCD",
    "90": "#B8B894",
    "91": "#00664C",
    "92": "#CCF5EB",
    "93": "#D6F5FF",
  },

  // http://color.hailpixel.com/#4B89C3,000000,B4903C,543A1C,5A7728,
  econColors: {
    mineral: "#5A7728",
    hydrocarbon: "#543A1C",
    construction: "#777777",
    nuclear: "#B4903C",
    coal: "#000000",
    aquifer: "#4B89C3",
    "1": "#33334C",
    "2": "#A3A3C2",
    "3": "#666699",
    "4": "#33334C",
    "5": "#A3A3C2",
    "6": "#666699",
    "7": "#666699",
    "8": "#A3A3C2",
    "9": "#33334C",
    "10": "#7A007A",
    "11": "#000066",
    "12": "#333300",
    "13": "#000000",
    "14": "#E6E600",
    "15": "#999966",
    "16": "#E6E600",
    "17": "#3385FF",
    "18": "#99C2FF",
    "19": "#85ADAD",
    "20": "#5C8A8A",
    "21": "#3385FF",
    "22": "#990033",
    "23": "#FFFF99",
  },
};

export default Config;
